import { render, staticRenderFns } from "./shoe-prints.vue?vue&type=template&id=8a4fc3ee&"
import script from "./shoe-prints.vue?vue&type=script&lang=js&"
export * from "./shoe-prints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports